export const NAVIGATION_URLS = {
    DASHBOARD: '/',

    // RESERVATION
    DASHBOARD_ADMIN_RESERVATION_DASHBOARD: '/admin/reservation/dashboard',
    DASHBOARD_ADMIN_RESERVATION: '/admin/reservation',
    DASHBOARD_ADMIN_RESERVATION_CALENDAR: '/admin/reservation/calendar',
    DASHBOARD_ADMIN_RESERVATION_AGENT_SETTINGS: '/admin/reservation/agent-settings',
    DASHBOARD_ADMIN_RESERVATION_ROOM_MAINTENANCE: '/admin/reservation/room-maintenance',
    DASHBOARD_ADMIN_RESERVATION_ACCOUNT_EXTRAS: '/admin/reservation/account-extras',
    DASHBOARD_ADMIN_RESERVATION_HOUSEKEEPING: '/admin/reservation/housekeeping',
    DASHBOARD_ADMIN_RESERVATION_STOCK_INVENTORY: '/admin/reservation/stock-inventory',
    DASHBOARD_ADMIN_RESERVATION_REPORTS: '/admin/reservation/reports',
    DASHBOARD_ADMIN_RESERVATION_REPORTS_OCCUPANCY: '/admin/reservation/reports/occupancy',
    DASHBOARD_ADMIN_RESERVATION_REPORTS_AGENT: '/admin/reservation/reports/agent',
    DASHBOARD_ADMIN_RESERVATION_REPORTS_REVENUE: '/admin/reservation/reports/revenue',
    DASHBOARD_ADMIN_RESERVATION_REPORTS_SALES: '/admin/reservation/reports/sales',
    DASHBOARD_ADMIN_RESERVATION_LOG: '/admin/reservation/log',

    // RESERVATION INVOICE
    DASHBOARD_ADMIN_RESERVATION_INVOICE_VIEW: '/admin/reservation/invoice/view',
    DASHBOARD_ADMIN_RESERVATION_INVOICE_VOUCHER: '/admin/reservation/invoice/voucher',
    DASHBOARD_ADMIN_RESERVATION_INVOICE_REGISTRATION_FORM: '/admin/reservation/invoice/registration-form',
    DASHBOARD_ADMIN_RESERVATION_INVOICE_GUEST_DETAIL_VIEW: '/admin/reservation/invoice/guest-detail-view',

    // PROPERTY SETTINGS
    DASHBOARD_ADMIN_PROPERTY_SETTINGS: '/admin/property-settings',
    DASHBOARD_ADMIN_PROPERTY_SETTINGS_PROPERTY_MANAGEMENT: '/admin/property-settings/property-management',

    // CHANNEL MANAGER
    DASHBOARD_ADMIN_CHANNEL_MANAGER: '/admin/channel-manager',
    DASHBOARD_ADMIN_CHANNEL_MANAGER_MONTHLY_SETUP: '/admin/channel-manager/monthly-setup',
    DASHBOARD_ADMIN_CHANNEL_MANAGER_CHANNEL_SETUP: '/admin/channel-manager/channel-setup',
    DASHBOARD_ADMIN_PROPERTY_SETTINGS_RATE: '/admin/channel-manager/rate',
    DASHBOARD_ADMIN_CHANNEL_MANAGER_REPORTS: '/admin/channel-manager/reports',
    DASHBOARD_ADMIN_CHANNEL_MANAGER_MESSAGE: '/admin/channel-manager/message',
    DASHBOARD_ADMIN_CHANNEL_MANAGER_ICALENDAR: '/admin/channel-manager/icalendar',
    DASHBOARD_ADMIN_CHANNEL_MANAGER_REVIEW: '/admin/channel-manager/review',

    // USER SETTINGS
    DASHBOARD_ADMIN_SETTINGS_USER_MANAGEMENT: '/admin/settings/user-management',
    DASHBOARD_ADMIN_SETTINGS_ROLES: '/admin/settings/roles',
    DASHBOARD_ADMIN_SETTINGS_PERMISSIONS: '/admin/settings/permissions',
    DASHBOARD_ADMIN_SETTINGS_GROUPS: '/admin/settings/groups',
    DASHBOARD_ADMIN_SETTINGS_REGIONS: '/admin/settings/regions',
    DASHBOARD_ADMIN_SETTINGS_INTEGRATIONS: '/admin/settings/integrations',

    // DYNAMIC PRICING
    // DASHBOARD_ADMIN_DYNAMIC_PRICING_GROUP: '/admin/price-intelligence-manager/group',
    DASHBOARD_ADMIN_DYNAMIC_PRICING_GROUP: '/admin/dynamic-pricing-manager/group',
    // DASHBOARD_ADMIN_DYNAMIC_PRICING_CALENDAR: '/admin/dynamic-pricing/calendar',

    // PROFILE
    DASHBOARD_ADMIN_PROFILE: '/admin/profile',
    DASHBOARD_ADMIN_CHANGE_PASSWORD: '/admin/change-password',
    DASHBOARD_ADMIN_MY_PROPERTY: '/admin/my-property',

    DASHBOARD_ADMIN_COMPANIES: '/admin/companies',
    DASHBOARD_ADMIN_GROUPS: '/admin/groups',

    DASHBOARD_ADMIN_INVENTORY_CATEGORIES: '/admin/inventory/categories',
    DASHBOARD_ADMIN_INVENTORY_ITEMS: '/admin/inventory/items',
    DASHBOARD_ADMIN_BOOKING_EXTRAS: '/admin/booking-extras',

    // SSO
    SSO_LOGIN: '/sso/login',
};